<template>
  <div class="flex justify-center mt-3">
    <button
      type="button"
      @click="signInWithApple"
      class="apple-sso-btn flex items-center justify-center gap-2 px-4 py-2 bg-black text-white rounded-md hover:bg-gray-900 transition-colors"
      style="width: 300px; height: 40px; font-size: 14px; font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;"
    >
      <i class="fab fa-apple" style="font-size: 18px;"></i>
      <span>Sign in with Apple</span>
    </button>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      loadingMessage: 'Verifying account',
    };
  },

  mounted() {
    this.loadAppleSDK();
  },

  methods: {
    loadAppleSDK() {
      if (document.getElementById('apple-auth-script')) {
        this.initApple();
        return;
      }
      const script = document.createElement('script');
      script.id = 'apple-auth-script';
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      script.async = true;
      script.onload = () => this.initApple();
      document.head.appendChild(script);
    },

    initApple() {
      if (!window.AppleID || !window.AppleID.auth) {
        setTimeout(() => this.initApple(), 200);
        return;
      }
      window.AppleID.auth.init({
        clientId: this.apple_bundle_id,
        scope: 'name email',
        redirectURI: window.location.origin + '/apiv3/appleCallback.json',
        usePopup: true,
      });
    },

    async signInWithApple() {
      if (!window.AppleID || !window.AppleID.auth) {
        this.$moshaToast('Apple Sign-In is not available yet. Please try again.', { type: 'danger' });
        return;
      }

      try {
        const response = await window.AppleID.auth.signIn();

        Swal.fire({
          title: 'Please wait...',
          html: '<small>Verifying Apple account</small>',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const res = await axios({
          method: 'post',
          url: this.baseAPIURL + '/apiv3/appleCallback',
          data: {
            token: response.authorization.id_token,
            device_identifier: 'TAPWEBIDENTIFIER',
            device_type: 'WEB',
            device_info: 'BROWSER',
            location: '',
            ip_public: '',
          },
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (res.data.data.result === 'success') {
          this.loadingMessage = 'Loading theme';
          Swal.update({ html: `<small>${this.loadingMessage}</small>` });

          const themeData = new FormData();
          themeData.append('email', res.data.data.email);

          const themeResponse = await axios({
            method: 'post',
            url: this.baseAPIURL + '/apiv3/theme.json',
            data: themeData,
            headers: {
              auth: res.data.data.token,
              'Content-Type': 'multipart/form-data',
            },
          });

          this.$store.dispatch('verify', {
            email: res.data.data.email,
            token: res.data.data.token,
            user_guid: res.data.data.guid,
          });

          this.$store.dispatch('updateNewLoad', true);
          Swal.close();
          this.$store.dispatch('updateTheme', themeResponse.data.theme[0].web_main_page_icon);

          res.data.data.data.book_code.map((item, index) => {
            if (index === 0) {
              if (this.$store.getters.selected_book === '') {
                this.$store.dispatch('activeBook', item.code);
                this.$store.dispatch('activeBookDesc', item.description);
                this.$store.dispatch('setPages', item.pages);
              }
              this.$store.dispatch('setBooks', item.code);
              this.$store.dispatch('setActiveBooks', item.code);
              this.$store.dispatch('setSelectedBookModDate', item.modified);
            } else {
              this.$store.dispatch('setBooks', item.code);
              this.$store.dispatch('setActiveBooks', item.code);
              this.$store.dispatch('setSelectedBookModDate', item.modified);
            }

            if (/@cloudstaff\.com\s*$/.test(res.data.data.email)) {
              this.$store.dispatch('setCS', true);
            } else {
              this.$store.dispatch('setCS', false);
            }
          });

          this.$moshaToast('Welcome!', { type: 'success' });
          this.$router.push('/dashboard');
        } else {
          Swal.close();
          this.$moshaToast('Apple sign-in failed. Please try again.', { type: 'danger' });
        }
      } catch (error) {
        Swal.close();
        if (error && error.error === 'popup_closed_by_user') {
          return;
        }
        this.$moshaToast('Apple sign-in failed. Please try again.', { type: 'danger' });
      }
    },
  },
};
</script>
